import { PartialDishSupplement } from "../../../../interfaces/meMenuInterfaces/interfaces";

export interface GroupOverrides {
    isRequireOnOrder?: boolean;
}

export const makeInputForUpdateGroup = (group: PartialDishSupplement, overrides: GroupOverrides = {}) => ({
    groupName: group.groupName,
    items: group.items?.map((item) => item.id) ?? [],
    options:
        group.options?.map((option) => ({
            ...(typeof option.id === "number" ? { id: option.id } : {}),
            name: option.name,
            price: option.price,
        })) ?? [],
    isRequireOnOrder: overrides.isRequireOnOrder ?? group.isRequireOnOrder,
    maxCountOnOrder: group.maxCountOnOrder,
});
